import { BaseRoute } from './base-route';
export class ComputedRoute extends BaseRoute {
  constructor(id, description, labelKey, type, wayPoints, distances, duration, estimatedDatetimeOfDeparture, estimatedDatetimeOfArrival, sections) {
    super(description, labelKey, type, wayPoints, distances, duration, estimatedDatetimeOfDeparture, estimatedDatetimeOfArrival, sections);
    this.id = id;
  }
  clone() {
    const wayPoints = [...this.wayPoints];
    const sections = [...this.sections];
    const clone = Object.assign({}, {
      ...this,
      wayPoints,
      sections
    });
    Object.setPrototypeOf(clone, ComputedRoute.prototype);
    return clone;
  }
}